import fetchApi from "../fetchApi";

export const UpdateSellSpecialtyItem = async (id, data) => {
  const options = {
    method: "PUT",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(data),
    redirect: "follow",
  };

  return await fetchApi(`card-issuing/specialty-items/${id}`, options);
};
